/*
 * @title: 
 * @Author: wangshuai
 * @Date: 2024-08-09 16:40:06
 * @FilePath: \飞行-运控\src\api\model\taskDirectives.js
 * @Description: 任务指令模块的接口
 * 
 */

import config from "@/config";
import http from "@/utils/request";

export default {
	jwTaskInstruction: {
		url: `${config.MAIN_URL}/api/v1/hw/jwTaskInstruction`,
		name1: "指令下发-新增",
		post: async function (data) {
			return await http.post(this.url, data);
		},
		name2: "指令下发-列表查询",
		get: async function (params) {
			return await http.get(this.url,params);
		},
		name3: "指令下发-修改",
		put: async function (data) {
			return await http.put(this.url, data);
		},
		name4: "指令下发-删除",
		delete: async function (params) {
			return await http.delete(this.url+ params);
		},

	},
	paginQueryPt: {
		url: `${config.MAIN_URL}/api/v1/hw/jwTaskInstruction/paginQueryPt`,
		name: "任务指令-列表查询",
		get: async function (params) {
			return await http.get(this.url , params);
		},

	},
	getXfr: {
		url: `${config.MAIN_URL}/api/v1/hw/jwTaskInstruction/getXfr`,
		name: "指令下发-查询下发人",
		get: async function (params) {
			return await http.get(this.url , params);
		},

	},
	byId: {
		url: `${config.MAIN_URL}/api/v1/hw/jwTaskInstruction/byId`,
		name: "指令-查询详情",
		get: async function (params) {
			return await http.get(this.url,params);
		},
	},
	jwIssueDetail: {
		url: `${config.MAIN_URL}/api/v1/hw/jwIssueDetail`,
		name: "任务指令-执行记录",
		get: async function (params) {
			return await http.get(this.url,params);
		},
	},
	confirm: {
		url: `${config.MAIN_URL}/api/v1/hw/jwIssueUser/confirm`,
		name: "任务指令-确认/执行/完成",
		put: async function (data) {
			return await http.put(this.url,data);
		},
	},
};
